import TestimonialImage1 from "@/assets/testimonials/1.jpg";
import TestimonialImage2 from "@/assets/testimonials/2.jpg";
import TestimonialImage3 from "@/assets/testimonials/3.jpg";
import TestimonialImage4 from "@/assets/testimonials/4.jpg";
import TestimonialImage5 from "@/assets/testimonials/5.jpg";

export const testimonialsArray = [
  TestimonialImage1,
  TestimonialImage2,
  TestimonialImage3,
  TestimonialImage4,
  TestimonialImage5,
];
